import {
  FixedAssetRegistryActionTypes,
  FixedAssetRegistryStateTypes,
} from "./FixedAssetRegistry.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: FixedAssetRegistryStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const FixedAssetRegistryReducer = (
  state: FixedAssetRegistryStateTypes = INITIAL_STATE,
  action: any
): FixedAssetRegistryStateTypes => {
  switch (action.type) {
    case FixedAssetRegistryActionTypes.FETCH_ALL_FIXED_ASSET_REGISTRY:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case FixedAssetRegistryActionTypes.FETCH_ALL_FIXED_ASSET_REGISTRY_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case FixedAssetRegistryActionTypes.FETCH_ALL_FIXED_ASSET_REGISTRY_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case FixedAssetRegistryActionTypes.FETCH_ALL_FIXED_ASSET_REGISTRY_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case FixedAssetRegistryActionTypes.FETCH_ONE_FIXED_ASSET_REGISTRY:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case FixedAssetRegistryActionTypes.FETCH_ONE_FIXED_ASSET_REGISTRY_RESET:
      return {
        ...state,
        fetchOne: resetApiCallState({}),
      };
    case FixedAssetRegistryActionTypes.FETCH_ONE_FIXED_ASSET_REGISTRY_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case FixedAssetRegistryActionTypes.FETCH_ONE_FIXED_ASSET_REGISTRY_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default FixedAssetRegistryReducer;
